import React from 'react';
import styled from 'styled-components';
import { Modal } from 'react-inv-forms';

interface Props {
  loading: boolean;
  [key: string]: any;
}
export const CustomModal = styled(Modal)`
  max-width: 90%;
  min-width: 80%;
  @media (max-width: 768px) {
    max-width: unset;
    min-width: 100%;
  }
`;
export const TableTransferContainer: React.FunctionComponent<Props> = styled(({ loading, children }: Props) => <div>{children}</div>)`
  opacity: ${({ loading }: Props): string => loading ? '0.2' : '1'};
  cursor: ${({ loading }: Props): string => loading ? 'not-allowed' : 'auto'};
  pointer-events: ${({ loading }: Props): string => loading ? 'none' : 'auto'};
`;

export const FlexBetweenContainer = styled.div`
  display: flex;
  justify-content: space-between;
  strong, span {
    font-size: 2rem;
  }
  @media(max-width: 567px) {
    strong, span {
      font-size: 1.4rem;
    }
  }

`;
export const FlexContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin: 20px 0 10px 0;
  & > div {
    padding-right: 60px;
  }
  & > div:last-of-type {
    width: 40%;
  }
  div.ant-select {
    width: 100%;
  }
  @media(max-width: 768px) {
    flex-wrap: wrap;
      & > div:last-of-type {
        width: 100%;
      }
  }
`;